import {Box, Grid} from "@mui/material";
import React, {FC} from "react";
import * as z from "zod";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import TextField from "@mui/material/TextField";
import {useGlobalActions} from "@/store/global.c";
import {QueryObserverResult, RefetchOptions} from "@tanstack/react-query";
import {DialogFooter} from "@/widget/DialogModal/DialogModal";

import {useConfirmLeave} from "@/service/leave.s";
import {emptyValue} from "@/helper/method";

export interface ConfirmLeaveProps {
    instanceId: number;
    businessId?: number;
    executeId: string;
    refetchExecutes: (options?: RefetchOptions) => Promise<QueryObserverResult>
}

const validationSchema = z.object({
    instanceId: z.number(),
    businessId: z.number().optional(),
    executeId: z.string(),
    // TODO
    leaveDays: z.string({message: "请填写请假天数"}).nonempty({message: '请填写请假天数'}).or(z.number({message: '请填写请假天数'})).refine((x: any) => {
        const reg = /^[1-9]\d*\.[5]$|0\.[5]$|^[1-9]\d*$/
        if (reg.test(x)) {
            return true
        }
        return false
    }, {message: "请填写正确的请假天数"}),
});

export type ConfirmLeaveForm = z.infer<typeof validationSchema>
const defaultValues = emptyValue(validationSchema)

export const ConfirmLeave: FC<ConfirmLeaveProps> = ({instanceId, executeId, businessId, refetchExecutes}) => {
    const {mutateAsync: confirmLeaveMutate, isPending: confirmLeavePending} = useConfirmLeave();

    const {
        handleSubmit,
        register,
        reset,
        formState: {errors},
    } = useForm<ConfirmLeaveForm>({
        resolver: zodResolver(validationSchema),
        values: {...defaultValues, businessId, instanceId, executeId},
    });
    const {setToast} = useGlobalActions()
    const {setDialogModal} = useGlobalActions()
    const onSubmit = async (values: ConfirmLeaveForm) => {
        const result = await confirmLeaveMutate({leaveDays: parseFloat(values.leaveDays as string), businessId, instanceId, executeId})
        if (result.code == 0) {
            setToast({message: result.msg, severity: 'success', open: true, duration: 2000});
            await refetchExecutes()
            setDialogModal({open: false})
        } else {
            setToast({message: result.msg, open: true, severity: 'error', duration: 2000});
        }
    }

    return <Box component={'form'} display={'flex'} flexDirection={'column'} rowGap={2} noValidate onSubmit={handleSubmit(onSubmit)}>
        <Grid spacing={2} container width={'inherit'}>
            <Grid size={12}>
                <TextField
                    {...register('leaveDays')}
                    type={'number'}
                    error={!!errors?.leaveDays}
                    helperText={errors?.leaveDays?.message}
                    placeholder="请假天数(0.5为半天，只能填写0.5的倍数)"
                    fullWidth
                />
            </Grid>
        </Grid>
        <DialogFooter onReset={() => reset(defaultValues)} loading={confirmLeavePending}/>
    </Box>
}